import { render } from "./Interes.vue?vue&type=template&id=90c5d8e4&scoped=true"
import script from "./Interes.vue?vue&type=script&lang=js"
export * from "./Interes.vue?vue&type=script&lang=js"

import "./Interes.vue?vue&type=style&index=0&id=90c5d8e4&scoped=true&lang=scss"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c5d8e4"]])

export default __exports__